import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';

import { ProUserService } from '../../services';
import { ProStatusType } from '../../types';

const GUARD_DEFAULT_REDIRECTS_BY_STATUS: { [key in ProStatusType]: string } = {
    lead: '/application',
    applicant: '/',
    active: '/',
    suspended: '/login',
    vacation: '/'
};

export function isGuardStatus(
    statuses: ProStatusType[],
    overrideDefaultRedirects?: { [key in ProStatusType]?: string }
): CanActivateFn {
    /* eslint-disable */
    return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
        const proUser = inject(ProUserService).user();
        const proStatus = proUser?.status;

        //Allow guard to continue if they have the matching status,
        //otherwise redirect them to either a custom path or a default path based on their current status
        if (!proUser) {
            inject(Router).navigateByUrl('/');
            return false;
        } else if (proStatus && statuses.indexOf(proStatus) === -1) {
            const path = overrideDefaultRedirects?.[proStatus] || GUARD_DEFAULT_REDIRECTS_BY_STATUS[proStatus] || '/';
            inject(Router).navigateByUrl(path);
            return false;
        } else {
            return true;
        }
    };
}
